import { ControllerBase } from "controllerBase";
import store from "../../redux/store/store";
import {sobrescreverInformacoesAction} from "../../redux/orcamentoSlice";
declare var orcamentoController:any
declare var window: any
import global from 'globalMU'
import { atualizarOrcamento } from "app/use-cases/orcamento/atualizarOrcamento";

window.TransportadoraOrcamentoController = ControllerBase.extend({
    name: "TransportadoraOrcamentoController",

    framework: "knockout",

    ajax: function () {

        return {
            url: "/Orcamento/_Transportadora",
            type: "post",
            cache: false,
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                TipoOrcamento: this.orcamento.get("TipoOrcamento")
            }
        };

    },

    newModel: function () {

        return {
            CodigoTransportadora: null,
            CodigoTransportadoraRedespacho: null,
            TipoFrete: null,
            TipoFreteEntrega: null,
            CodigoRoteiroEntrega: null,
            TipoTransportadora: null,
            ClassificacaoFrete: null,
            ValorCustoFrete: null,
            HabilitaEdicaoCustoFrete: null,
            CustoFretePendente: null
            //ObservacaoNF: null,
            //ObservacaoOrcamento: null,
            //UsarObservacaoTextoLivreNF: false
        };
    },

    antesRenderizacaoCompleta: function () {

        this.atualizarBotoes();

    },

    aposBinding: function () {
        for (var item in this.model.__ko_mapping__.mappedProperties) {
            this.model[item].subscribe(function () {
                orcamentoController.model.DadosAlteradosEntrega["transportadora"] = true;
            });
        }
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    atualizarBotoes: function () {

        this.addActionButton({
            text: "Limpar",
            'class': "icone-excluir separador",
            click: $.proxy(function () {

                global.clearFormFields({
                    selector: this.formConfig.selector
                });

            },
                this)
        },
            true);

    },

    formConfig: {
        selector: "#form-transportadora",
        submit: {
            selector: "#salvar-transportadora",
            loadingText: "Aguarde...",
            callback: "salvar",
            type: "model",
            modelType: "js"
        },
        rules: {
            'Transportadora': {
                required: false
            },
            'TipoFrete': {
                required: true
            },
            'Roteiro': {
                required: function () {
                    return this.model.roteiroObrigatorio();
                }
            }
        },
        messages: {
            'Transportadora': {
                required: 'O campo "Transportadora" é obrigatório.'
            },
            'TipoFrete': {
                required: 'O campo "Tipo de Frete" é obrigatório.'
            },
            'Roteiro': {
                required: 'O campo "Roteiro" é obrigatório.'
            }
        }

    },

    salvar: function (model, e) {
        var self = this;
        global.ajax({
            url: "/Orcamento/DefinirTransportadora",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                transportadora: model,
                TipoOrcamento: this.orcamento.get("TipoOrcamento")
            }),
            success: async function (data) {

                if (!data || data.HasErrors) {
                    return;
                }

                const orcamento = window.store.getState().orcamento
                const novoOrcamento = {
                    ...orcamento,
                    Transportadora: {
                        ClassificacaoFrete: data.Transportadora.ClassificacaoFrete,
                        CodigoRoteiroEntrega: data.Transportadora.CodigoRoteiroEntrega,
                        CodigoTransportadora: data.Transportadora.CodigoTransportadora,
                        CodigoTransportadoraRedespacho: data.Transportadora.CodigoTransportadoraRedespacho,
                        CustoFretePendente: data.Transportadora.CustoFretePendente,
                        HabilitaEdicaoCustoFrete: data.Transportadora.HabilitaEdicaoCustoFrete,
                        TipoFrete: data.Transportadora.TipoFrete,
                        TipoTransportadora: data.Transportadora.TipoTransportadora,
                        UserMessage: null,
                        ValorCustoFrete: data.Transportadora.ValorCustoFrete
                    }
                }
                store.dispatch(sobrescreverInformacoesAction(novoOrcamento))

                self.orcamento.set("Transportadora", data.Transportadora);

                self.model.CodigoTransportadora(data.Transportadora.CodigoTransportadora);
                self.model.CodigoTransportadoraRedespacho(data.Transportadora.CodigoTransportadoraRedespacho);
                self.model.TipoFrete(data.Transportadora.TipoFrete);
                self.model.CodigoRoteiroEntrega(data.Transportadora.CodigoRoteiroEntrega);
                self.model.TipoTransportadora(data.Transportadora.TipoTransportadora);
                self.model.ClassificacaoFrete(data.Transportadora.ClassificacaoFrete);
                self.model.ValorCustoFrete(data.Transportadora.ValorCustoFrete);
                self.model.HabilitaEdicaoCustoFrete(data.Transportadora.HabilitaEdicaoCustoFrete);
                self.model.CustoFretePendente(data.Transportadora.CustoFretePendente);
                //self.model.ObservacaoNF(data.Transportadora.ObservacaoNF);
                //self.model.ObservacaoOrcamento(data.Transportadora.ObservacaoOrcamento);
                //self.model.UsarObservacaoTextoLivreNF(data.Transportadora.UsarObservacaoTextoLivreNF);

                await atualizarOrcamento()

                if (!data.HasErrors) {
                    global.showSuccessMessage("Transportadora definida com sucesso.");
                    self.orcamento.DadosAlteradosEntrega["transportadora"] = false;
                }

            }
        });
    }

});
